import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { SarlaftOperationsProps } from './props';
import { useSarlaftlaftOperations } from './hook';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftOperations = (props: SarlaftOperationsProps) => {
    const { formik, cities, countries } = useSarlaftlaftOperations(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Operaciones
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Tipo de producto"
                    name="typeProduct"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeProduct}
                    errors={formik.errors.typeProduct}
                    value={formik.values.typeProduct}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de producto"
                    name="numberProduct"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.numberProduct}
                    errors={formik.errors.numberProduct}
                    value={formik.values.numberProduct}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Entidad"
                    name="entity"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.entity}
                    errors={formik.errors.entity}
                    value={formik.values.entity}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Monto"
                    name="amount"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.amount}
                    errors={formik.errors.amount}
                    value={formik.values.amount}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(cities)}
                    label="Ciudad"
                    name="foreignCity"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.foreignCity}
                    errors={formik.errors.foreignCity}
                    value={formik.values.foreignCity}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('foreignCity', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(countries)}
                    label="País"
                    name="country"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.country}
                    errors={formik.errors.country}
                    value={formik.values.country}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('country', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Moneda"
                    name="currency"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.currency}
                    errors={formik.errors.currency}
                    value={formik.values.currency}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
